// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__2Kltm","tabs":"Sidebar_tabs__1T_NJ","tab":"Sidebar_tab__2_bAY","active":"Sidebar_active__1llhg","container":"Sidebar_container__EQ8Tj"};